import React from 'react'
import { FormattedBookingCancellationPolicy } from '../../../../models/property-details-page/booking-cancellation-policy-model'
import { NotesSectionTitleWrapper } from '../notes/styles'
import { Typography } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import RuleRenderer from './rule-renderer'

interface BookingCancellationProps {
    policy?: FormattedBookingCancellationPolicy | null
    arrivalDate: Date | null
}

const BookingCancellationPolicy: React.FC<BookingCancellationProps> = ({ policy, arrivalDate }) => {
    const { t } = useTranslation()

    return (
        <React.Fragment>
            <NotesSectionTitleWrapper>
                <Typography variant={'subtitle2'} fontWeight="semiBold">
                    {t('bookingCancellationPolicy.heading')}
                </Typography>
            </NotesSectionTitleWrapper>
            {policy?.rules?.fullRefund && (
                <RuleRenderer
                    rules={policy.rules.fullRefund}
                    type="fullRefund"
                    isSlab={false}
                    arrivalDate={arrivalDate}
                />
            )}
            {policy?.rules?.noRefund && (
                <RuleRenderer rules={policy.rules.noRefund} type="noRefund" isSlab={false} arrivalDate={arrivalDate} />
            )}
            {policy?.rules?.slab?.fullRefund && (
                <RuleRenderer rules={policy.rules.slab.fullRefund} type="fullRefund" isSlab arrivalDate={arrivalDate} />
            )}
            {policy?.rules?.slab?.partialRefund && (
                <RuleRenderer
                    rules={policy.rules.slab.partialRefund}
                    type="partialRefund"
                    isSlab
                    arrivalDate={arrivalDate}
                />
            )}
            {policy?.rules?.slab?.noRefund && (
                <RuleRenderer rules={policy.rules.slab.noRefund} type="noRefund" isSlab arrivalDate={arrivalDate} />
            )}
        </React.Fragment>
    )
}

export default BookingCancellationPolicy
